export class RequestByName{
    visitorName: any;

    /**
     * 
     * @param visitorName
     */
    constructor(visitorName: any){
        this.visitorName = visitorName;


    }
}